/* eslint-disable no-console */
import useJSONStore from '../../../store/StaticJson/jsonStore';
import {inputType} from '../../esgManager/interface/inputType';

export const renderQuestionType = (fieldType: string): string => {
  switch (fieldType) {
    case inputType.MULTISELECT:
    case inputType.TEXTAREA:
      return 'text';
    case inputType.WYSIWYG:
      return 'html';
    case 'datepickerrange':
      return 'daterange';
    case 'date':
    case 'number':
    case 'email':
    case 'currency':
    case 'percentage':
    case 'list':
    case 'link':
    case 'table':
      return fieldType;
    case inputType.ADD_NEW_TO_TABLE:
    case inputType.ADD_FIXED_ROW_TO_TABLE:
      return 'table';
    default:
      return 'text';
  }
};
export const formatDate = (input: any): string => {
  const convertISTtoUTC = (dateStr: any) => {
    const date = new Date(dateStr);

    if (isNaN(date.getTime())) return '';

    const utcTime = new Date(date.getTime() - 5.5 * 60 * 60 * 1000);

    return utcTime.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC'
    });
  };

  const parseInput = (val: any) => {
    if (typeof val === 'string') {
      try {
        const parsed = JSON.parse(val);

        return parsed;
      } catch {
        return val;
      }
    }

    return val;
  };

  const parsedInput = parseInput(input);

  if (Array.isArray(parsedInput)) {
    return parsedInput.map(convertISTtoUTC).join(' - ');
  }

  return convertISTtoUTC(parsedInput);
};

export const renderValue = (value: any, fieldType: string): any => {
  const countryOptions = useJSONStore.getState().country;
  switch (fieldType) {
    case inputType.COUNTRY:
      return countryOptions.find((item: any) => item.value === value)?.label;
    case inputType.DATE_RANGE_PICKER:
    case inputType.DATEPICKER:
      return formatDate(value);
    default:
      return value;
  }
};
